/*
 * File: /src/constants.js
 * Created Date: Saturday April 27th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 27th April 2019 11:09:59 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

export const AB_ASSETS_URL = 'https://s3.amazonaws.com/adbase-email-assets/';

export const S2_VER_URL = '/v1/';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyCCgZ_aLu-8RIkN3_Ml8Mfv8wr7F7VVjio';

// FIXME: get these from the server.
export const STRIPO_PLUGIN_ID =
  process.env.STRIPO_PLUGIN_ID ?? '1df8cfb1de754955bfe59fe846f32c23';
export const STRIPO_SECRET_KEY =
  process.env.STRIPO_SECRET_KEY ?? 'd79687c0402c4b4091ca64befc93ae29';

// Paths for Service entities
export const AD_BASE_AGENTS_PATH = S2_VER_URL + 'agents/';
export const AD_BASE_APPCONFIG_PATH = S2_VER_URL + 'config/app-config/';
export const AD_BASE_SPLIT_CONVERSATION_EMAILS_PATH =
  S2_VER_URL + 'config/split-conversation-emails/';
export const AD_BASE_BLOCKED_NUMBERS_PATH = S2_VER_URL + 'blocked-numbers/';
export const AD_BASE_BRAND_PATH = S2_VER_URL + 'brands/';
export const AD_BASE_DIAL_DESTINATION_PATH = S2_VER_URL + 'dial-destinations/';
export const AD_BASE_WORKFLOW_PATH = S2_VER_URL + 'workflows/';
export const AD_BASE_TRIGGER_CONFIG_PATH = S2_VER_URL + 'triggers/config/';
export const AD_BASE_INITIATE_PATH = S2_VER_URL + 'initiate/';
export const AD_BASE_CALLPLAN_PATH = S2_VER_URL + 'call-plans/';
export const AD_BASE_CONNECTOR_PATH = S2_VER_URL + 'connectors/';
export const AD_BASE_CONNECTOR_MAP_PATH = S2_VER_URL + 'connector-map/';
export const AD_BASE_CONTACTS_PATH = S2_VER_URL + 'contacts/';
export const AD_BASE_CONTENT_BLOCK_PATH = S2_VER_URL + 'content-blocks/';
export const AD_BASE_DIRECT_DIAL_PATH = S2_VER_URL + 'direct-dials/';
export const AD_BASE_OVERVIEW_PATH = S2_VER_URL + 'overview/';
export const AD_BASE_ACCOUNTS_PATH = S2_VER_URL + 'accounts/';
export const AD_BASE_DISP_PATH = S2_VER_URL + 'dispositions/';
export const AD_BASE_ANALYTICS_PATH = S2_VER_URL + 'analytics/';
export const AD_BASE_MESSAGES_PATH = S2_VER_URL + 'messages/';
export const AD_BASE_GROUPS_PATH = S2_VER_URL + 'groups/';
export const AD_BASE_GROUP_CONTACT_PATH = S2_VER_URL + 'group-contacts/';
export const AD_BASE_FOLDERS_PATH = S2_VER_URL + 'folders/';
export const AD_BASE_FORM_FIELD_PROFILE_PATH = S2_VER_URL + 'form-field-profiles/';
export const AD_BASE_DOMAINS_PATH = S2_VER_URL + 'domains/';
export const AD_BASE_TEMPLATES_PATH = S2_VER_URL + 'templates/';
export const AD_BASE_POSTCARD_TEMPLATES_PATH =
  S2_VER_URL + 'postcard-templates/';
export const S2_POSTCARD_MESSAGES_PATH = S2_VER_URL + 'postcard-messages/';
export const AD_BASE_TEMPLATES_SMS_CHAT_PATH =
  S2_VER_URL + 'template-sms-chats/';
export const AD_BASE_SMS_CHAT_CAMPAIGN_PATH =
  S2_VER_URL + 'sms-chat-campaigns/';
export const AD_BASE_SMS_CHAT_HOURS_PATH = S2_VER_URL + 'sms-chat-hours/';
export const AD_BASE_ACTIONS_PATH = S2_VER_URL + 'actions/';
export const AD_BASE_ASSETS_PATH = S2_VER_URL + 'assets/';
export const AD_BASE_EXPORT_PATH = S2_VER_URL + 'exports/';
export const AD_BASE_CAMPAIGNS_PATH = S2_VER_URL + 'campaigns/';
export const AD_BASE_AGENCY_PATH = S2_VER_URL + 'agency/';
export const AD_BASE_LEAD_PATH = S2_VER_URL + 'leads/';
export const AD_BASE_LEAD_CATEGORY_PATH = S2_VER_URL + 'lead-categories/';
export const AD_BASE_LEAD_STATUS_PATH = S2_VER_URL + 'lead-status/';
export const AD_BASE_LEAD_SOURCE_PATH = S2_VER_URL + 'lead-sources/';
export const AD_BASE_LEAD_SOURCE_DETAIL_PATH = S2_VER_URL + 'lead-source-details/';
export const S2_LEAD_TYPE_PATH = S2_VER_URL + 'lead-types/';
export const S2_LEAD_TYPE_PROFILE_PATH = S2_VER_URL + 'lead-type-profiles/';
export const AD_BASE_LOST_REASON_PATH = S2_VER_URL + 'lost-reasons/';
export const AD_BASE_LOST_REASON_DETAIL_PATH = S2_VER_URL + 'lost-reason-details/';
export const AD_BASE_USER_PATH = S2_VER_URL + 'user/';
export const AD_BASE_BETA_PATH = S2_VER_URL + 'beta/';
export const AD_BASE_TAGS_PATH = S2_VER_URL + 'tags/';
export const AD_BASE_TASKS_PATH = S2_VER_URL + 'tasks/';
export const AD_BASE_INTERESTS_PATH = S2_VER_URL + 'interests/';
export const AD_BASE_REFERRALS_PATH = S2_VER_URL + 'referrals/';
export const AD_BASE_RESERVATIONS_PATH = S2_VER_URL + 'reservations/';
export const AD_BASE_NOTES_PATH = S2_VER_URL + 'notes/';
export const S2_USER_NOTIFICATIONS_PATH = S2_VER_URL + 'notifications/';
export const AD_BASE_BILLING_PATH = S2_VER_URL + 'billing/';
export const AD_BASE_PIPELINE_PATH = S2_VER_URL + 'pipeline/';
export const AD_BASE_GOOGLE_PATH = S2_VER_URL + 'google/';
export const AD_BASE_CONTACTS_COMPANIES_PATH =
  AD_BASE_CONTACTS_PATH + 'companies/';
export const AD_BASE_COMPANY_PATH = S2_VER_URL + 'company/';
export const AD_BASE_SMSSERVICES_PATH = S2_VER_URL + 'twilio/'; // twilio only
export const AD_BASE_PHONE_NUMBER_PATH = S2_VER_URL + 'phone-numbers/';
export const AD_BASE_SMS_PATH = S2_VER_URL + 'sms/';
export const AD_BASE_LINKED_IN_PATH = S2_VER_URL + 'linkedin/';
export const AD_BASE_VOICE_SERVICES_PATH = S2_VER_URL + 'voice/';
export const AD_BASE_CALL_SERVICES_PATH = S2_VER_URL + 'calls/';
export const AD_BASE_CUSTOM_FIELDS_PATH = S2_VER_URL + 'custom-fields/';
export const AD_BASE_CUSTOM_DATA_PATH = S2_VER_URL + 'custom-data/';
export const AD_BASE_TEAM_PATH = S2_VER_URL + 'team/';
export const AD_BASE_QUEUE_PATH = S2_VER_URL + 'queues/';
export const AD_BASE_VOICE_PATH = S2_VER_URL + 'voice/';
export const AD_BASE_VALIDATION_PATH = S2_VER_URL + 'validation/';
export const AD_BASE_VOICEMAIL_PATH = S2_VER_URL + 'voicemails/';
export const AD_BASE_REPORT_PATH = S2_VER_URL + 'reports/';
export const AD_BASE_REPORT_EXEC_PATH = S2_VER_URL + 'reports/run/';
export const AD_BASE_REPORT_ROLLUP_PATH = S2_VER_URL + 'report-rollups/';
export const AD_BASE_EVENT_PATH = S2_VER_URL + 'events/';
export const AD_BASE_METRIC_PATH = S2_VER_URL + 'company-metric/';
export const AD_BASE_SUBSCRIPTION_PATH = S2_VER_URL + 'subscription/';
export const AD_BASE_UNITS_PATH = S2_VER_URL + 'units/';
export const AD_BASE_OWNERS_PATH = S2_VER_URL + 'owners/';
export const AD_BASE_WEBHOOK_PATH = S2_VER_URL + 'webhooks/';
export const AD_BASE_SURVEY_PATH = S2_VER_URL + 'surveys/';
export const AD_BASE_CONTACT_SURVEY_PATH = S2_VER_URL + 'contact-surveys/';
export const AD_BASE_UNSUBSCRIBES_PATH = S2_VER_URL + 'unsubscribes/';
export const S2_AIRBNB_PATH = S2_VER_URL + 'airbnb/';
export const S2_AIRBNB_TEMPLATE_PATH = S2_VER_URL + 'airbnb-templates/';
export const S2_CONVERSATION_PATH = S2_VER_URL + 'conversations/';
export const S2_CONTACT_TIMELINE_PATH = S2_VER_URL + 'contact-timeline/';
export const S2_WHATSAPP_PATH = S2_VER_URL + 'whatsapp/';
export const S2_WHATSAPP_TEMPLATE_PATH = S2_VER_URL + 'whatsapp-templates/';
export const S2_EMAIL_TEMPLATES_PATH = S2_VER_URL + 'email-templates/';
export const S2_CALL_RESULT_PATH = S2_VER_URL + 'voice/call-results/';
export const S2_CALL_TYPE_DETAIL_PATH = S2_VER_URL + 'call-type-details/';
export const S2_GUIDEBOOKS_PATH = S2_VER_URL + 'guidebooks/';
export const S2_GUIDEBOOK_THEMES_PATH = S2_VER_URL + 'guidebook-themes/';
export const S2_KPI_GOAL_PATH = S2_VER_URL + 'kpi-goals/';
export const S2_CONVERSATION_SCORES_PATH = S2_VER_URL + 'conversation-scores/';
export const S2_SCORING_CRITERIA_PATH = S2_VER_URL + 'scoring-criteria/';
export const S2_SCORING_TEMPLATES_PATH = S2_VER_URL + 'scoring-templates/';
export const S2_AI_CONTEXT_TYPES_PATH = S2_VER_URL + 'ai-context-types/';
export const S2_AI_CONTEXT_CONFIG_PATH = S2_VER_URL + 'ai-context-types/config/';
export const S2_AI_AGENTS_PATH = S2_VER_URL + 'ai-agents/';
export const S2_KNOWLEDGE_TYPES_PATH = S2_VER_URL + 'knowledge-types/';
export const S2_KNOWLEDGE_CATEGORIES_PATH =
  S2_VER_URL + 'knowledge-categories/';
export const S2_KNOWLEDGE_PATH = S2_VER_URL + 'knowledge/';
export const S2_AI_SESSIONS_PATH = S2_VER_URL + 'ai-sessions/';

export const S2_LOGIN_PATH = S2_VER_URL + 'login/';
export const S2_TASK_TYPE_PATH = S2_VER_URL + 'task-types/';

// Admin routes.  At some point we'll want extra security on these
